<script setup lang="ts">
interface Props {
  isNotFixedHeight: boolean
  desktop?: boolean
  isCart?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  isNotFixedHeight: false,
  desktop: false,
  isCart: false,
})

const classList = computed(() => {
  return {
    'content__wrapper_not-fixed': props.isNotFixedHeight,
    content__wrapper_desktop: props.desktop,
    'content__wrapper_cart content__wrapper_white': props.isCart && props.desktop,
  }
})
</script>

<template>
  <div class="content__wrapper" :class="classList">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.content {
  &__wrapper {
    background-color: $bg-gray;
    padding: 16px;

    border-radius: 16px 16px 0px 0px;
    min-height: calc(100dvh - 40px);
    //min-height: calc(100vh - 40px - $safe-area-bottom - $safe-area-top);
    padding-bottom: calc(16px + #{$safe_area_bottom} + var(--footer-pad));

    &.setting {
      padding-bottom: 0;
    }

    &_not-fixed {
      height: 100%;
    }

    &_desktop {
      min-height: 100%;
      height: 100%;
      padding: 0;
    }

    &_cart {
      height: 1px;
    }

    &_white {
      background-color: white;
    }
  }
}
</style>
